<footer class="init-footer">
  <nav>
    <ul>
      <li><a class="fs-unmask" [href]="privacyPolicyUrl" target="_blank">Privacy Policy</a></li>
      <li><a class="fs-unmask" [href]="termsOfUseUrl" target="_blank">Term of Use</a></li>
      <span class="divider fs-unmask">
        Company NMLS
        <ng-container *ngIf="companyNmls; else emptyNMLS">
          <a class="nmls-consumer-access" [href]="nmlsConsumerAccessUrl+companyNmls"
             target="_blank">#{{companyNmls}}</a>
        </ng-container>
      </span>
    </ul>
  </nav>
  <div class="compliance-container">
    <span class="powered-by fs-unmask">
      Powered by LendWize <sup> TM</sup>
    </span>
    <span class="ehq divider" *ngIf="complianceLogoUrl">
      <img [src]="complianceLogoUrl">
    </span>
  </div>
</footer>
<ng-template #emptyNMLS>
  {{'&#45;&#45;'}}
</ng-template>
